import React from 'react';

const Svg = (props) => (
  <span {...props}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="15" height="15" rx="1.27778" fill="white" stroke="white"/>
      <path d="M7.24624 9.6496C7.17984 9.7415 7.04863 9.75605 6.9637 9.68092L4.21168 7.24631C3.84843 6.92497 3.29409 6.95634 2.96943 7.31662C2.64158 7.68044 2.67205 8.24149 3.03739 8.56765L6.51955 11.6765C6.90881 12.024 7.51198 11.9645 7.82579 11.5475L12.6125 5.1881C12.8815 4.83062 12.8349 4.32723 12.5049 4.02518C12.1218 3.67467 11.5188 3.7364 11.2147 4.15726L7.24624 9.6496Z" fill="black" fill-opacity="0.8"/>
    </svg>
  </span>
);

export default Svg;
